import { ConnectionBanner } from '../ui/components/ConnectionBanner';
import { Toasts } from '../ui/components/Toasts';
import { Dialogs } from '../ui/dialogs/Dialogs';
import { GameHost } from '../ui/screens/GameHost';
import { LoginScreen } from '../ui/screens/LoginScreen';
import { ReplacedScreen, UpdateScreen } from '../ui/screens/NoticeScreen';
import { ProfileScreen } from '../ui/screens/ProfileScreen';
import { ResultsScreen } from '../ui/screens/ResultsScreen';
import { RoomScreen } from '../ui/screens/RoomScreen';
import { StatsScreen } from '../ui/screens/StatsScreen';
import { SeasonDecor } from '../ui/season/SeasonDecor';
import { useApp } from './context';
import type { ScreenId } from './screen';

/** Root component: the current screen plus the overlays (dialogs, banner, toasts). */
export function App() {
  const app = useApp();
  const screen = app.screen.value;
  const season = app.settings.season.value;
  // While a dialog is open the screen behind it takes no focus, taps or screen-reader visits.
  const behindDialog = app.ui.dialog.value !== null;
  return (
    <>
      <div class="screen-layer" inert={behindDialog}>
        <Screen id={screen} />
      </div>
      {/* Holiday decorations around the shell screens (the race draws its own). */}
      {season !== 'none' && screen !== 'game' && <SeasonDecor season={season} screen={screen} />}
      <Dialogs />
      <ConnectionBanner />
      <Toasts />
    </>
  );
}

function Screen({ id }: { id: ScreenId }) {
  switch (id) {
    case 'update':
      return <UpdateScreen />;
    case 'replaced':
      return <ReplacedScreen />;
    case 'login':
      return <LoginScreen />;
    case 'profile':
      return <ProfileScreen />;
    case 'game':
      return <GameHost />;
    case 'results':
      return <ResultsScreen />;
    case 'stats':
      return <StatsScreen />;
    case 'room':
      return <RoomScreen />;
  }
}
